import { render, staticRenderFns } from "./MakeRecommend.vue?vue&type=template&id=9f15586c&scoped=true&"
import script from "./MakeRecommend.vue?vue&type=script&lang=js&"
export * from "./MakeRecommend.vue?vue&type=script&lang=js&"
import style0 from "./MakeRecommend.vue?vue&type=style&index=0&id=9f15586c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f15586c",
  null
  
)

export default component.exports